import React, { useEffect, useState, useRef } from 'react'
import {
  IonSlides,
  IonSlide,
  IonSkeletonText,
  IonButton,
  getPlatforms
} from '@ionic/react'
import YokIcon from '../YokIcon'
import ContentCircleCard from '../ContentCircleCard'
import ContentCircleCardSkeleton from '../../skeletons/ContentCircleCardSkeleton'
import { getContentFeed } from '../../../services/api/contents'
import './styles.scss'

const RadioCategoryLatestSwipper = props => {
  const [contents, SetContents] = useState([])
  const [isBeginning, SetIsBeginning] = useState(true)
  const [isEnd, SetIsEnd] = useState(false)
  const [showNavigation, setShowNavigation] = useState(false)
  const slidesRef = useRef()
  const slideOpts = {
    initialSlide: 0,
    slidesPerView: 'auto',
    preventClicks: true,
    speed: 400,
    pagination: true
  }
  const slideWdth = 120

  const transitionEnd = () => {
    slidesRef.current.isBeginning().then((response) => { SetIsBeginning(response) })
    slidesRef.current.isEnd().then((response) => { SetIsEnd(response) })
  }

  const prevSlide = () => {
    slidesRef.current.slidePrev()
  }

  const nextSlide = () => {
    slidesRef.current.slideNext()
  }

  useEffect(() => {
    const params = {}
    if (typeof props.category !== 'undefined') {
      params.category = props.category
    }
    if (typeof props.section !== 'undefined') {
      params.section = props.section
    }
    getContentFeed(params).then((response) => {
      SetContents(response)
    }).catch(() => {
      SetContents([])
    })
  }, [])

  useEffect(() => {
    if (typeof slidesRef.current !== 'undefined' && typeof contents !== 'undefined') {
      setShowNavigation((slideWdth * contents.length > slidesRef.current.clientWidth) && getPlatforms().includes('desktop'))
    }
  }, [contents])

  return (
    <section className='radio-category-latest-swipper'>
      {contents.length > 0 &&
        <>
          <h1 className='category-title'>Lo más nuevo</h1>
          <IonSlides
            ref={slidesRef}
            options={slideOpts}
            onIonSlideDidChange={() => transitionEnd()}
          >
            {contents.map((content) => (
              <IonSlide key={content.id}>
                <ContentCircleCard content={content} hideTitle={props.hideTitle} />
              </IonSlide>
            ))}
          </IonSlides>
          {showNavigation &&
            <>
              <IonButton
                className='pagination prev'
                onClick={prevSlide}
                disabled={isBeginning}
              >
                <YokIcon name='arrow_back_ios' />
              </IonButton>
              <IonButton
                className='pagination next'
                onClick={nextSlide}
                disabled={isEnd}
              >
                <YokIcon name='arrow_forward_ios' />
              </IonButton>
            </>}
        </>}

      {contents.length === 0 &&
        <>
          <IonSkeletonText className='category-title' />
          <IonSlides options={slideOpts}>
            <IonSlide>
              <ContentCircleCardSkeleton />
            </IonSlide>
            <IonSlide>
              <ContentCircleCardSkeleton />
            </IonSlide>
            <IonSlide>
              <ContentCircleCardSkeleton />
            </IonSlide>
            <IonSlide>
              <ContentCircleCardSkeleton />
            </IonSlide>
            <IonSlide>
              <ContentCircleCardSkeleton />
            </IonSlide>
            <IonSlide>
              <ContentCircleCardSkeleton />
            </IonSlide>
          </IonSlides>
        </>}
    </section>
  )
}

export default RadioCategoryLatestSwipper
